
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/knowledge-upload",
      function () {
        return require("private-next-pages/docs/knowledge-upload.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/knowledge-upload"])
      });
    }
  